import React, { useState, useEffect, useCallback } from 'react';
import clienteService from '../../services/cliente.service';
import BtnIcone from '../../components/BtnIcone';
import SePode from '../../components/SePode';   // r88: botões condicionais por permissão
import Modal from '../../components/Modal';
import GridValores from '../../components/GridValores';
import BrowseHeader from '../../components/BrowseHeader';                    // r106
import { iconeDaRotina } from '../../constants/iconesRotinas';               // r106

// Formata CNPJ para exibição no browse: 00.000.000/0000-00
function formatarCnpj(cnpj) {
  const n = (cnpj || '').replace(/\D/g, '');
  if (n.length !== 14) return cnpj;
  return `${n.slice(0,2)}.${n.slice(2,5)}.${n.slice(5,8)}/${n.slice(8,12)}-${n.slice(12)}`;
}

const COR = {
  azul:     '#003399',
  azulBg:   '#eff6ff',
  borda:    '#e8eaed',
  texto:    '#1a1a2e',
  muted:    '#888',
  branco:   '#fff',
  verde:    '#1D9E75',
  verdeBg:  '#f0fff4',
  vermelho: '#e53935',
  vermBg:   '#fff0f0',
  amarelo:  '#d97706',
  amlBg:    '#fffbeb',
  cinzaBg:  '#fafbfc',
};

const inputStyle = {
  width: '100%', height: '36px', padding: '0 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto, outline: 'none',
  fontFamily: "'Manrope', sans-serif",
};

const selectStyle = { ...inputStyle, cursor: 'pointer' };

const textareaStyle = {
  width: '100%', padding: '8px 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto,
  outline: 'none', resize: 'vertical', minHeight: '80px',
  fontFamily: "'Manrope', sans-serif",
};

const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG',
             'PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

// r137: máscara CEP
function mascararCep(valor) {
  const nums = String(valor || '').replace(/\D/g, '').slice(0, 8);
  if (nums.length <= 5) return nums;
  return `${nums.slice(0, 5)}-${nums.slice(5)}`;
}
function limparCep(valor) {
  return String(valor || '').replace(/\D/g, '').slice(0, 8);
}

// ─── r137: SVGs (padrão Colaborador) ──────────────────────────────────────────
const SvgCliente = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <line x1="9" y1="7" x2="9" y2="7"/>
    <line x1="9" y1="11" x2="9" y2="11"/>
    <line x1="9" y1="15" x2="9" y2="15"/>
    <line x1="15" y1="7" x2="15" y2="7"/>
    <line x1="15" y1="11" x2="15" y2="11"/>
    <line x1="15" y1="15" x2="15" y2="15"/>
  </svg>
);
const SvgEndereco = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const SvgOutros = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const SvgValores = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>
    <line x1="12" y1="6" x2="12" y2="18"/>
  </svg>
);
const SvgChevron = ({ size = 14, color = 'currentColor', aberto }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
       style={{
         transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)',
         transition: 'transform 0.15s',
       }}>
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

// ─── r137: Seção expansível (padrão Colaborador) ─────────────────────────────
function Secao({ icone: Icone, titulo, aberta, onToggle, children, fixa }) {
  const estaAberta = fixa ? true : aberta;
  return (
    <div style={{
      border: `1px solid ${COR.borda}`, borderRadius: '6px',
      marginBottom: '12px', overflow: 'visible', backgroundColor: COR.branco,
    }}>{/* r169: era overflow:'hidden' — cortava a paleta de cor da tag (dropdown
         absoluto que vaza a borda da seção). z-index não resolve isso; quem
         corta é o overflow do pai. Sem animação de recolher, liberar é seguro. */}
      <div
        onClick={fixa ? undefined : onToggle}
        style={{
          padding: '12px 16px',
          backgroundColor: estaAberta ? COR.azulBg : COR.cinzaBg,
          borderBottom: estaAberta ? `1px solid ${COR.borda}` : 'none',
          cursor: fixa ? 'default' : 'pointer',
          userSelect: 'none',
          display: 'flex', alignItems: 'center', gap: '10px',
          transition: 'background-color 0.15s',
        }}
      >
        {Icone && (
          <span style={{ display: 'inline-flex', color: estaAberta ? COR.azul : COR.muted }}>
            <Icone size={18} />
          </span>
        )}
        <span style={{
          flex: 1, fontSize: '14px', fontWeight: '700',
          color: estaAberta ? COR.azul : COR.texto,
        }}>
          {titulo}
        </span>
        {!fixa && (
          <span style={{ display: 'inline-flex', color: COR.muted }}>
            <SvgChevron aberto={estaAberta} size={16} />
          </span>
        )}
      </div>
      {estaAberta && <div style={{ padding: '16px' }}>{children}</div>}
    </div>
  );
}

// ─── Status pill ──────────────────────────────────────────────────────────────
function StatusPill({ status }) {
  const ativo = status === 'A';
  const cor = ativo ? COR.verde : COR.amarelo;
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: ativo ? COR.verdeBg : COR.amlBg,
      color: cor,
      border: `1px solid ${cor}`,           // r108: borda na cor da fonte
    }}>{ativo ? 'Ativo' : 'Inativo'}</span>
  );
}

// ─── Tag colorida do cliente ──────────────────────────────────────────────────
function TagCliente({ tag, cor }) {
  if (!tag) return null;
  const bgCor = cor || '#003399';
  // Calcula luminância para decidir cor do texto
  const hex = bgCor.replace('#', '');
  const r = parseInt(hex.substr(0,2),16);
  const g = parseInt(hex.substr(2,2),16);
  const b = parseInt(hex.substr(4,2),16);
  const lum = (0.299*r + 0.587*g + 0.114*b) / 255;
  const corTexto = lum > 0.5 ? '#1a1a2e' : '#ffffff';

  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: bgCor, color: corTexto,
      letterSpacing: '0.3px',
    }}>{tag}</span>
  );
}

// ─── r137: Campo (label 2px, padrão Colaborador) ─────────────────────────────
function Campo({ label, children, obrigatorio, metade }) {
  return (
    <div style={{ marginBottom: '0', width: metade ? 'calc(50% - 5px)' : '100%' }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: COR.muted, marginBottom: '2px' }}>
        {label}{obrigatorio && <span style={{ color: COR.vermelho }}> *</span>}
      </label>
      {children}
    </div>
  );
}

function Linha({ children }) {
  return <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>{children}</div>;
}

// r137: PreviewTag removida — a prévia agora é mostrada como uma TagCliente inline,
//       junto com os campos Tag/Cor Tag/Status na seção Dados do Cliente.

// Aplica máscara visual: 00.000.000/0000-00
function mascararCnpj(valor) {
  const nums = valor.replace(/\D/g, '').slice(0, 14);
  if (nums.length <= 2)  return nums;
  if (nums.length <= 5)  return `${nums.slice(0,2)}.${nums.slice(2)}`;
  if (nums.length <= 8)  return `${nums.slice(0,2)}.${nums.slice(2,5)}.${nums.slice(5)}`;
  if (nums.length <= 12) return `${nums.slice(0,2)}.${nums.slice(2,5)}.${nums.slice(5,8)}/${nums.slice(8)}`;
  return `${nums.slice(0,2)}.${nums.slice(2,5)}.${nums.slice(5,8)}/${nums.slice(8,12)}-${nums.slice(12)}`;
}

const FORM_VAZIO = {
  razao_social: '', nome_fantasia: '', cnpj: '', insc_municipal: '',
  insc_estadual: '', logradouro: '', numero: '', complemento: '',
  bairro: '', municipio: '', uf: '', cep: '',
  tag: '', cor_tag: '#003399',
  // r137: novos campos read-only vindos do GridValores
  vlr_hora_projeto: '', vlr_hora_sustentacao: '', vlr_hora_pontual: '',
  vlr_mensal_sd: '', desconto: '', acrescimo: '',
  email_cat: '', dados_bancarios: '',
  contatos_tecnicos: '', contatos_financeiros: '',
  status: 'A',
};

// Converte null/undefined → string vazia para evitar inputs não controlados
function sanitizar(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [k, v === null || v === undefined ? '' : v])
  );
}

// ─── Componente principal ─────────────────────────────────────────────────────
const PALETA_CORES = [
  '#003399','#1D9E75','#e53935','#d97706','#7c3aed',
  '#0891b2','#059669','#dc2626','#9333ea','#0284c7',
  '#16a34a','#ca8a04','#db2777','#0d9488','#65a30d',
  '#4f46e5','#c2410c','#0369a1','#15803d','#b45309',
  '#111827','#374151','#6b7280','#9ca3af','#d1d5db',
];

function ClientesPage() {
  const [clientes, setClientes]         = useState([]);
  const [carregando, setCarregando]     = useState(true);
  const [busca, setBusca]               = useState('');
  const [ordenacao, setOrdenacao]       = useState({ campo: 'nome_fantasia', dir: 'asc' });

  const [painel, setPainel]             = useState(null);
  const [selecionado, setSelecionado]   = useState(null);
  // r137: abas removidas, substituídas por seções fixas/expansíveis
  const [form, setForm]                 = useState(FORM_VAZIO);
  const [salvando, setSalvando]         = useState(false);
  const [erroPainel, setErroPainel]     = useState('');
  const [mostrarPaleta, setMostrarPaleta] = useState(false);
  const [sucessoPainel, setSucessoPainel] = useState('');

  // r137: estado das seções expansíveis
  const [secoes, setSecoes] = useState({
    endereco: true,   // começa aberta
    valores:  false,  // r139: começa fechada
    outros:   false,  // começa fechada
  });
  const toggleSec = (k) => setSecoes(s => ({ ...s, [k]: !s[k] }));

  // r137: modal de Valores sobreposto (não é mais aba)
  const [modalValores, setModalValores] = useState(false);

  // ── Carregar ─────────────────────────────────────────────────────────────────
  const carregar = useCallback(async () => {
    try {
      setCarregando(true);
      const lista = await clienteService.listar();
      setClientes(lista);
    } catch {
      setClientes([]);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  // ── Filtro e ordenação ───────────────────────────────────────────────────────
  const listaFiltrada = clientes
    .filter(c => {
      const q = busca.toLowerCase();
      return !q
        || c.nome_fantasia.toLowerCase().includes(q)
        || c.razao_social.toLowerCase().includes(q)
        || (c.cnpj || '').includes(q)
        || (c.tag || '').toLowerCase().includes(q);
    })
    .sort((a, b) => {
      const va = (a[ordenacao.campo] || '').toString().toLowerCase();
      const vb = (b[ordenacao.campo] || '').toString().toLowerCase();
      return ordenacao.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    });

  const toggleOrdem = (campo) =>
    setOrdenacao(o => ({ campo, dir: o.campo === campo && o.dir === 'asc' ? 'desc' : 'asc' }));

  const setaCabecalho = (campo) => {
    if (ordenacao.campo !== campo) return ' ↕';
    return ordenacao.dir === 'asc' ? ' ↑' : ' ↓';
  };

  // ── Ações ─────────────────────────────────────────────────────────────────────
  const abrirNovo = () => {
    setForm(FORM_VAZIO);
    setSelecionado(null);
    setErroPainel(''); setSucessoPainel('');
    setPainel('novo');
  };

  const abrirVisualizar = (c) => {
    setSelecionado(c);
    setForm(sanitizar({ ...FORM_VAZIO, ...c }));
    setErroPainel(''); setSucessoPainel('');
    setPainel('visualizar');
  };

  const abrirEditar = (c) => {
    setSelecionado(c);
    setForm(sanitizar({ ...FORM_VAZIO, ...c }));
    setErroPainel(''); setSucessoPainel('');
    setPainel('editar');
  };

  const fecharPainel = () => { setPainel(null); setSelecionado(null); };

  // Recarrega lista e atualiza o form do cliente aberto após mudança de valores
  const recarregarSelecionado = useCallback(async () => {
    if (!selecionado?.id) { await carregar(); return; }
    try {
      const lista = await clienteService.listar();
      setClientes(lista);
      const atualizado = lista.find(x => x.id === selecionado.id);
      if (atualizado) setForm(f => ({ ...f, ...sanitizar(atualizado) }));
    } catch { await carregar(); }
  }, [carregar, selecionado]);

  const handleCampo = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const alterarStatus = async (c) => {
    try {
      await clienteService.alterarStatus(c.id, c.status === 'A' ? 'I' : 'A');
      await carregar();
    } catch { alert('Erro ao alterar status.'); }
  };

  // ── Validar CNPJ (formato básico) ─────────────────────────────────────────────
  const cnpjValido = (cnpj) => cnpj.replace(/\D/g, '').length === 14;

  // ── Salvar ────────────────────────────────────────────────────────────────────
  const salvar = async () => {
    setErroPainel('');
    if (!form.razao_social.trim())  return setErroPainel('Razão Social é obrigatória.');
    if (!form.nome_fantasia.trim()) return setErroPainel('Nome Fantasia é obrigatório.');
    if (!form.cnpj.trim())          return setErroPainel('CNPJ é obrigatório.');
    if (!cnpjValido(form.cnpj))     return setErroPainel('CNPJ deve ter 14 dígitos.');
    if (!form.logradouro.trim())    return setErroPainel('Logradouro é obrigatório.');
    if (!form.numero.trim())        return setErroPainel('Número é obrigatório.');
    if (!form.bairro.trim())        return setErroPainel('Bairro é obrigatório.');
    if (!form.municipio.trim())     return setErroPainel('Município é obrigatório.');
    if (!form.uf)                   return setErroPainel('UF é obrigatória.');
    if (!form.cep.trim())           return setErroPainel('CEP é obrigatório.');
    if (!form.tag.trim())           return setErroPainel('Tag é obrigatória.');
    if (!form.cor_tag.trim())       return setErroPainel('Cor da Tag é obrigatória.');

    try {
      setSalvando(true);
      if (painel === 'novo') {
        await clienteService.incluir(form);
      } else {
        await clienteService.alterar(selecionado.id, form);
      }
      setSucessoPainel(painel === 'novo' ? 'Cliente incluído com sucesso!' : 'Cliente alterado com sucesso!');
      await carregar();
      setTimeout(fecharPainel, 1200);
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || 'Erro ao salvar. Verifique os dados.');
    } finally {
      setSalvando(false);
    }
  };

  const somenteLeitura = painel === 'visualizar';
  const corTagValida = /^#[0-9A-Fa-f]{6}$/.test(form.cor_tag);

  // ─── Render ───────────────────────────────────────────────────────────────────
  return (
    <div style={{ fontFamily: "'Manrope', sans-serif" }}>

      {/* r106: BrowseHeader padronizado no topo */}
      <BrowseHeader
        rotina="clientes"
        titulo="Clientes"
        descricao="Cadastro dos clientes atendidos e seus dados comerciais."
      />

      {/* ── BROWSE ── */}
      <div style={{
        flex: 1, backgroundColor: COR.branco,
        border: `1px solid ${COR.borda}`, borderRadius: '8px',
        overflow: 'hidden', minWidth: 0,
      }}>
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${COR.borda}`,
          display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: '13px', fontWeight: '500', color: COR.muted, flex: 1 }}>
            {listaFiltrada.length} registro{listaFiltrada.length !== 1 ? 's' : ''}
          </span>
          <input
            type="text" placeholder="Pesquisar..."
            value={busca} onChange={e => setBusca(e.target.value)}
            style={{ ...inputStyle, width: '320px' }}
          />
          <SePode rotina="clientes" acao="incluir"><BtnIcone icone="incluir" onClick={abrirNovo} title="Incluir novo cliente" cor={COR.azul} solido tamanho="grande" /></SePode>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: COR.azul }}>
                {/* r106: 1ª coluna fixa pro ícone SVG da rotina */}
                <th style={{ padding: '10px 14px', width: '36px' }}></th>
                {[
                  { label: 'Tag',            campo: 'tag'           },
                  { label: 'Nome fantasia',  campo: 'nome_fantasia' },
                  { label: 'Razão social',   campo: 'razao_social'  },
                  { label: 'CNPJ',           campo: 'cnpj'          },
                  { label: 'Status',         campo: 'status'        },
                  { label: 'Ações',          campo: null            },
                ].map(({ label, campo }) => (
                  <th key={label} onClick={() => campo && toggleOrdem(campo)} style={{
                    padding: '10px 14px', textAlign: 'left',
                    fontSize: '13px', fontWeight: '700', color: COR.branco,
                    whiteSpace: 'nowrap', cursor: campo ? 'pointer' : 'default', userSelect: 'none',
                  }}>
                    {label}{campo && setaCabecalho(campo)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr><td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Carregando...</td></tr>
              ) : listaFiltrada.length === 0 ? (
                <tr><td colSpan="7" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Nenhum cliente encontrado.</td></tr>
              ) : listaFiltrada.map((c, i) => (
                <tr key={c.id} onClick={() => abrirVisualizar(c)} style={{
                  borderBottom: `1px solid ${COR.borda}`,
                  backgroundColor: selecionado?.id === c.id ? COR.azulBg : i % 2 === 0 ? COR.branco : '#fafafa',
                  cursor: 'pointer',
                }}>
                  {/* r106: ícone SVG #003399 da rotina (mesmo do menu lateral) */}
                  <td style={{ padding: '10px 0 10px 14px', verticalAlign: 'middle' }}>
                    {iconeDaRotina('clientes', { width: 20, height: 20, color: COR.azul })}
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <TagCliente tag={c.tag} cor={c.cor_tag} />
                  </td>
                  <td style={{ padding: '10px 14px', fontWeight: '500', color: COR.texto }}>{c.nome_fantasia}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{c.razao_social}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{formatarCnpj(c.cnpj)}</td>
                  <td style={{ padding: '10px 14px' }}><StatusPill status={c.status} /></td>
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', gap: '4px' }} onClick={e => e.stopPropagation()}>
                      <SePode rotina="clientes" acao="alterar"><BtnIcone icone="alterar" onClick={() => abrirEditar(c)} title="Alterar" cor={COR.azul} /></SePode>
                      <SePode rotina="clientes" acao="alterar"><BtnIcone
                        icone={c.status === 'A' ? 'bloquear' : 'desbloquear'}
                        onClick={() => alterarStatus(c)}
                        title={c.status === 'A' ? 'Inativar' : 'Ativar'}
                        cor={c.status === 'A' ? COR.vermelho : COR.verde}
                      /></SePode>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── MODAL ── */}
      <Modal
        aberto={!!painel}
        titulo={painel === 'novo' ? 'Novo Cliente' : painel === 'editar' ? 'Alterar Cliente' : 'Visualizar Cliente'}
        onFechar={fecharPainel}
        onSalvar={salvar}
        salvando={salvando}
        somenteLeitura={somenteLeitura}
        onEditar={() => setPainel('editar')}
        // r137: header rico padronizado (igual Colaborador)
        rotina="clientes"
        descricao="Cadastro dos clientes atendidos e seus dados comerciais."
        botoesNoTopo={true}
        largura="95vw"
        // r137: botão Gerenciar Valores no header (igual Colaborador)
        botoesExtras={
          <button
            type="button"
            onClick={() => setModalValores(true)}
            disabled={!selecionado?.id}
            title={!selecionado?.id ? 'Salve o cliente antes de gerenciar valores' : 'Abrir tela de Valores'}
            style={{
              padding: '8px 18px',
              border: `1px solid ${!selecionado?.id ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.5)'}`,
              borderRadius: '5px',
              backgroundColor: 'transparent',
              color: !selecionado?.id ? 'rgba(255,255,255,0.45)' : '#fff',
              fontSize: '13px', fontWeight: '500',
              cursor: !selecionado?.id ? 'not-allowed' : 'pointer',
              fontFamily: "'Manrope', sans-serif",
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            <SvgValores size={14} />
            Gerenciar Valores
          </button>
        }
      >
        <div>

            {erroPainel && (
              <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
                {erroPainel}
              </div>
            )}
            {sucessoPainel && (
              <div style={{ backgroundColor: COR.verdeBg, border: `1px solid #a8e6c1`, borderRadius: '5px', color: '#1d6a3a', fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
                {sucessoPainel}
              </div>
            )}

            {/* ═══ r137: Seções (modelo Colaborador) ═══ */}

            {/* ── SEÇÃO DADOS DO CLIENTE (fixa) ────────────────────────── */}
            <Secao icone={SvgCliente} titulo="Dados do Cliente" fixa>
              {/* Razão Social | Nome Fantasia */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <Campo label="Razão Social" obrigatorio>
                  <input name="razao_social" value={form.razao_social} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Razão Social" />
                </Campo>
                <Campo label="Nome Fantasia" obrigatorio>
                  <input name="nome_fantasia" value={form.nome_fantasia} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Nome Fantasia" />
                </Campo>
              </div>

              {/* CNPJ | Insc. Estadual | Insc. Municipal */}
              <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 1fr', gap: '10px', marginTop: '20px' }}>
                <Campo label="CNPJ" obrigatorio>
                  <input
                    name="cnpj"
                    value={mascararCnpj(form.cnpj)}
                    onChange={e => setForm(f => ({ ...f, cnpj: e.target.value.replace(/\D/g, '') }))}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="00.000.000/0000-00" maxLength={18}
                  />
                </Campo>
                <Campo label="Insc. Estadual">
                  <input name="insc_estadual" value={form.insc_estadual} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="IE" maxLength={12} />
                </Campo>
                <Campo label="Insc. Municipal">
                  <input name="insc_municipal" value={form.insc_municipal} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="IM" maxLength={20} />
                </Campo>
              </div>

              {/* Status | Tag | Cor Tag | Prévia */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr 1fr 1fr', gap: '10px', marginTop: '20px', alignItems: 'end' }}>
                <Campo label="Status" obrigatorio>
                  <select name="status" value={form.status} onChange={handleCampo} disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                    <option value="A">Ativo</option>
                    <option value="I">Inativo</option>
                  </select>
                </Campo>
                <Campo label="Tag" obrigatorio>
                  <input name="tag" value={form.tag} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Ex: ACME" maxLength={12} />
                </Campo>
                <Campo label="Cor Tag" obrigatorio>
                  <div style={{ position: 'relative' }}>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <input
                        name="cor_tag"
                        value={form.cor_tag}
                        onChange={handleCampo}
                        disabled={somenteLeitura}
                        style={{ ...inputStyle, flex: 1 }}
                        placeholder="#003399"
                        maxLength={7}
                      />
                      {/* Botão abre paleta */}
                      {!somenteLeitura && (
                        <div
                          onClick={() => setMostrarPaleta(v => !v)}
                          title="Selecionar cor"
                          style={{
                            width: '36px', height: '36px', borderRadius: '5px',
                            backgroundColor: corTagValida ? form.cor_tag : '#e8eaed',
                            border: `2px solid ${mostrarPaleta ? COR.azul : COR.borda}`,
                            flexShrink: 0, cursor: 'pointer',
                            transition: 'border-color 0.15s',
                          }}
                        />
                      )}
                      {somenteLeitura && (
                        <div style={{
                          width: '36px', height: '36px', borderRadius: '5px',
                          backgroundColor: corTagValida ? form.cor_tag : '#e8eaed',
                          border: `1px solid ${COR.borda}`, flexShrink: 0,
                        }} />
                      )}
                    </div>
                    {/* Paleta de cores */}
                    {mostrarPaleta && !somenteLeitura && (
                      <div style={{
                        position: 'absolute', top: '42px', right: 0,
                        backgroundColor: '#fff',
                        border: `1px solid ${COR.borda}`,
                        borderRadius: '8px',
                        padding: '10px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                        zIndex: 10,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(5, 28px)',
                        gap: '6px',
                      }}>
                        {PALETA_CORES.map(cor => (
                          <div
                            key={cor}
                            title={cor}
                            onClick={() => {
                              setForm(f => ({ ...f, cor_tag: cor }));
                              setMostrarPaleta(false);
                            }}
                            style={{
                              width: '28px', height: '28px',
                              borderRadius: '5px',
                              backgroundColor: cor,
                              cursor: 'pointer',
                              border: form.cor_tag === cor ? '2px solid #1a1a2e' : '2px solid transparent',
                              transition: 'transform 0.1s',
                            }}
                            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.15)'}
                            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </Campo>
                <Campo label="Prévia">
                  <div style={{
                    height: '36px', display: 'flex', alignItems: 'center',
                    padding: '0 10px',
                    border: `1px dashed ${COR.borda}`, borderRadius: '5px',
                    backgroundColor: COR.cinzaBg,
                  }}>
                    {form.tag
                      ? <TagCliente tag={form.tag} cor={corTagValida ? form.cor_tag : '#003399'} />
                      : <span style={{ fontSize: '12px', color: COR.muted, fontStyle: 'italic' }}>—</span>}
                  </div>
                </Campo>
              </div>
            </Secao>

            {/* ── SEÇÃO ENDEREÇO (expansível, começa aberta) ──────────── */}
            <Secao icone={SvgEndereco} titulo="Endereço"
                   aberta={secoes.endereco} onToggle={() => toggleSec('endereco')}>
              {/* Logradouro | Número | Complemento */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 0.6fr 1fr', gap: '10px' }}>
                <Campo label="Logradouro" obrigatorio>
                  <input name="logradouro" value={form.logradouro} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Rua, Av., Travessa..." />
                </Campo>
                <Campo label="Número" obrigatorio>
                  <input name="numero" value={form.numero} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Nº" maxLength={8} />
                </Campo>
                <Campo label="Complemento">
                  <input name="complemento" value={form.complemento} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Apto, Sala..." />
                </Campo>
              </div>

              {/* Bairro | Município | UF | CEP */}
              <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.2fr 0.5fr 1fr', gap: '10px', marginTop: '20px' }}>
                <Campo label="Bairro" obrigatorio>
                  <input name="bairro" value={form.bairro} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Bairro" />
                </Campo>
                <Campo label="Município" obrigatorio>
                  <input name="municipio" value={form.municipio} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Município" />
                </Campo>
                <Campo label="UF" obrigatorio>
                  <select name="uf" value={form.uf} onChange={handleCampo} disabled={somenteLeitura} style={somenteLeitura ? inputStyle : selectStyle}>
                    <option value="">UF</option>
                    {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                  </select>
                </Campo>
                <Campo label="CEP" obrigatorio>
                  <input
                    name="cep"
                    value={mascararCep(form.cep)}
                    onChange={e => setForm(f => ({ ...f, cep: limparCep(e.target.value) }))}
                    disabled={somenteLeitura} style={inputStyle}
                    placeholder="00000-000" maxLength={9}
                  />
                </Campo>
              </div>
            </Secao>

            {/* ── r139: SEÇÃO VALORES (expansível, começa fechada) ────── */}
            <Secao icone={SvgValores} titulo="Valores"
                   aberta={secoes.valores} onToggle={() => toggleSec('valores')}>
              {/* Linha 1: Vlr. Hora Projeto | Vlr. Hora Sustentação | Vlr. Hora Pontual */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                <Campo label="Vlr. Hora Projeto">
                  <input
                    value={form.vlr_hora_projeto
                      ? parseFloat(form.vlr_hora_projeto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      : '—'}
                    disabled
                    style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                  />
                </Campo>
                <Campo label="Vlr. Hora Sustentação">
                  <input
                    value={form.vlr_hora_sustentacao
                      ? parseFloat(form.vlr_hora_sustentacao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      : '—'}
                    disabled
                    style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                  />
                </Campo>
                <Campo label="Vlr. Hora Pontual">
                  <input
                    value={form.vlr_hora_pontual
                      ? parseFloat(form.vlr_hora_pontual).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      : '—'}
                    disabled
                    style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                  />
                </Campo>
              </div>

              {/* Linha 2: Vlr. Mensal SD | % Desconto | % Acréscimo */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginTop: '20px' }}>
                <Campo label="Vlr. Mensal SD">
                  <input
                    value={form.vlr_mensal_sd
                      ? parseFloat(form.vlr_mensal_sd).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      : '—'}
                    disabled
                    style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                  />
                </Campo>
                <Campo label="% Desconto">
                  <input
                    value={form.desconto ? parseFloat(form.desconto).toFixed(2) + '%' : '—'}
                    disabled
                    style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                  />
                </Campo>
                <Campo label="% Acréscimo">
                  <input
                    value={form.acrescimo ? parseFloat(form.acrescimo).toFixed(2) + '%' : '—'}
                    disabled
                    style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                  />
                </Campo>
              </div>

              <div style={{ fontSize: '11px', color: COR.muted, marginTop: '10px' }}>
                Valores vigentes (gerenciados pelo botão <b>Gerenciar Valores</b> no topo).
              </div>
            </Secao>

            {/* ── SEÇÃO OUTROS DADOS (expansível, começa fechada) ─────── */}
            <Secao icone={SvgOutros} titulo="Outros Dados"
                   aberta={secoes.outros} onToggle={() => toggleSec('outros')}>
              {/* E-mail para envio de CAT */}
              <Campo label="E-mail para envio de CATs" obrigatorio>
                <input name="email_cat" type="email" value={form.email_cat} onChange={handleCampo}
                       disabled={somenteLeitura} style={inputStyle} placeholder="financeiro@cliente.com.br" />
              </Campo>

              <div style={{ marginTop: '20px' }}>
                <Campo label="Contato Técnico">
                  <textarea name="contatos_tecnicos" value={form.contatos_tecnicos} onChange={handleCampo}
                            disabled={somenteLeitura} style={textareaStyle}
                            placeholder="Nome, telefone, e-mail dos contatos técnicos..." />
                </Campo>
              </div>

              <div style={{ marginTop: '20px' }}>
                <Campo label="Contato Administrativo/Financeiro">
                  <textarea name="contatos_financeiros" value={form.contatos_financeiros} onChange={handleCampo}
                            disabled={somenteLeitura} style={textareaStyle}
                            placeholder="Nome, telefone, e-mail dos contatos administrativos/financeiros..." />
                </Campo>
              </div>

              <div style={{ marginTop: '20px' }}>
                <Campo label="Dados Bancários">
                  <textarea name="dados_bancarios" value={form.dados_bancarios} onChange={handleCampo}
                            disabled={somenteLeitura} style={textareaStyle}
                            placeholder="Banco, agência, conta, PIX, nome do titular..." />
                </Campo>
              </div>
            </Secao>

        </div>

        {/* r137: Modal de Valores sobreposto (renderiza por cima do modal principal) */}
        {modalValores && (
          <Modal
            aberto={modalValores}
            titulo={`Valores — ${form.nome_fantasia || form.razao_social || 'Cliente'}`}
            onFechar={() => setModalValores(false)}
            onSalvar={() => setModalValores(false)}
            salvando={false}
            somenteLeitura={somenteLeitura}
            rotina="clientes"
            descricao="Gerenciamento de valores (hora projeto/sustentação/pontual, mensal SD, desconto e acréscimo) do cliente."
            botoesNoTopo={true}
            largura="90vw"
          >
            <GridValores
              vinculo="L"
              idVinculo={selecionado?.id}
              nome={form.nome_fantasia}
              somenteLeitura={somenteLeitura}
              onAtualizado={recarregarSelecionado}
            />
          </Modal>
        )}
      </Modal>
    </div>
  );
}

export default ClientesPage;
